angular.module('unergie.main')
.directive('validationClusters', ($timeout, NgTableParams, CommonRegex, ApiUser, AlertManager, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/perimeterValidation/validationClusters/validationClusters.html',
        scope: {
            clusters: '=',
            showValidation: '=',
        },
        link($scope) {
            $scope.$watch('clusters', () => {
                $scope.clustersTable = new NgTableParams({}, { dataset: $scope.clusters })
            })
            const siretPattern = /\d{14}/

            $scope.siretValid = (siret) => {
                return siret && siret.match(siretPattern)
            }

            $scope.formatReimbursement = (bool) => {
                if (bool === true) {
                    return 'Report'
                } else if (bool === false) {
                    return 'Remboursement'
                }
                return '*vide*'
            }

            const phoneRegexAll = CommonRegex.phone.french
            $scope.testPhone = (value) => {
                return phoneRegexAll.test(value)
            }

            $scope.checkDifference = (cluster, fields) => {
                if (cluster.previous) {
                    const fArray = _.isArray(fields) ? fields : [fields]
                    return _.some(fArray, (f) => (cluster[f] || cluster.previous[f]) && `${cluster[f]}` !== `${cluster.previous[f]}`)
                }
                return false
            }

            $scope.checkSiret = (cluster, e) => {
                e.preventDefault()
                e.stopPropagation()
                cluster.siretValidationResult = null
                if (cluster.siret && $scope.siretValid(cluster.siret)) {
                    cluster.checkingSiret = true
                    return ApiUser.validateSiret({ siret: cluster.siret, source: 'ALL', store: true }).$promise.then((siretValidationResult) => {
                        _.each($scope.clusters, (cl) => {
                            if (cl.siret === cluster.siret) {
                                cl.siretValidationResult = siretValidationResult
                            }
                        })
                        AlertManager.success(`Le SIRET appartient à : ${siretValidationResult.legal_name}, ` +
                            `${siretValidationResult.bill_addr_num_street} ${siretValidationResult.bill_addr_post_code} ${siretValidationResult.bill_addr_city_lbl}`)
                    })
                    .catch(ErrorCatcher)
                    .finally(() => {
                        $timeout(() => {
                            cluster.checkingSiret = false
                        })
                    })
                }
            }
        },
    }),
)
